import React from "react";
import Layout from "../components/layout";
import { useStaticQuery, graphql } from "gatsby";
import { Card, Col } from "react-bootstrap";

const Prizes = ({ items }) => {
  return (
    <span>
      {" – "}
      <ul className="event-prizes">
        {items.map(item => {
          return <li>{item}</li>;
        })}
      </ul>
    </span>
  );
};

const Event = ({ info }) => {
  return (
    <li>
      {info.name && <div className="event-title">{info.name}</div>}
      <span>
        {info.role && <span className="event-role">{info.role}</span>}
        {info.prizes && <Prizes items={info.prizes} />}
      </span>
    </li>
  );
};

const EventType = ({ info }) => {
  const eventItems = info.items.map(event => {
    return <Event info={event} />;
  });

  return (
    <Card>
      <Card.Header>{info.title}</Card.Header>
      <Card.Body>
        <Col>
          <ul>{eventItems}</ul>
        </Col>
      </Card.Body>
    </Card>
  );
};

const EventsPage = () => {
  const data = useStaticQuery(graphql`
    {
      dataYaml {
        events {
          title
          items {
            title
            items {
              name
              role
              prizes
            }
          }
        }
      }
    }
  `).dataYaml.events.items;

  const eventTypeItems = data.map(event => <EventType info={event} />);

  return <Layout title="Events">{eventTypeItems}</Layout>;
};

export default EventsPage;
